import React, {useState} from 'react';
import {Card} from 'antd';
import {OrganizationTree} from '../../components/OrganizationTree';
import {RolePermissionPanel} from '../../components/RolePermissionPanel';
import './index.scss';

export function OrganizationManage() {
  const [selectedNode, setSelectedNode] = useState<any>(null);

  return (
    <div className="drive-org-manage">
      <div className="drive-org-manage__header">
        <div>
          <h2>组织目录管理</h2>
          <p>配置左侧导航组织、部门，以及角色可见范围</p>
        </div>

        {/*未来可能会添加新建组织功能*/}
        {/*<Button type="primary" icon={<PlusOutlined/>}>*/}
        {/*  新增组织*/}
        {/*</Button>*/}
      </div>

      <div className="drive-org-manage__body">
        <Card className="drive-org-manage__tree-card">
          <OrganizationTree
            selectedId={selectedNode?.id}
            onSelect={setSelectedNode}
          />
        </Card>

        <RolePermissionPanel node={selectedNode}/>
      </div>
    </div>
  );
}